import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    textVariables: [],
    documentTypes: [],
    docTypeContents: [],
}

const getters = {
    getTextVariables: (state) => state.textVariables,
    getAllDocTypes: (state) => state.documentTypes,
    getContents: (state) => state.docTypeContents
}

const actions = {
    async getTextVariablesList( context, data) {
        await axios.get(`${backendUrl()}/getTextVariablesList`,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setTextVariables', response.data)
        })
    },
    async deleteTextVariable( context, data ) {
        await axios.post(`${backendUrl()}/deleteTextVariable`, 
        {
            varId: data.varId 
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getTextVariablesList')
        })
    },
    async addTextVariable( context, data ) {
        await axios.post(`${backendUrl()}/addTextVariable`,
        {
            name: data.name
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getTextVariablesList')
        })
    },
    async getAllDocumentTypeList( context, data ) {
        await axios.get(`${backendUrl()}/getAllDocumentTypeList`, 
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setDocumentTypes', response.data)
        })
    },
    async getTextVariableContnets( context, data ) {
        await axios.get(`${backendUrl()}/getTextVariableContnets`, 
        {
            params: {
                docTypeId: data.docTypeId
            },
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setDocTypeContents', response.data)
        })
    },
    async updateTextVariableContents( context, data) {
        await axios.post(`${backendUrl()}/updateTextVariableContents`, 
        {
            docTypeId: data.docTypeId,
            contents: data.contents 
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    }
}

const mutations = {
    setTextVariables: (state, textVariables) => (state.textVariables = textVariables),
    setDocumentTypes: (state, documentTypes) => (state.documentTypes = documentTypes),
    setDocTypeContents: (state, docTypeContents) => (state.docTypeContents = docTypeContents)
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}